'use strict';

function buildRequestBody(bodyParameters) {
    const keys = Object.keys(bodyParameters);
    if (keys.length === 0) {
        return undefined;
    }
    return (keys.length === 1 ? bodyParameters[keys[0]] : bodyParameters);
}

exports.buildRequestBody = buildRequestBody;
//# sourceMappingURL=buildRequestBody.js.map
